import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const SpinnerContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`;

const SpinnerRing = styled.div<{ delay?: number }>`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #007aff;
  border-right-color: #007aff;
  animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: ${({ delay }) => delay || 0}s;
`;

const SpinnerCore = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007aff 0%, #3394ff 100%);
  animation: ${pulse} 1.5s ease-in-out infinite;
  box-shadow: 0 0 20px rgba(0, 122, 255, 0.5);
`;

const SpinnerGlow = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 122, 255, 0.1) 0%, transparent 70%);
  animation: ${pulse} 2s ease-in-out infinite;
`;

interface ModernSpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: 40,
  medium: 60,
  large: 80,
};

export const ModernSpinner: React.FC<ModernSpinnerProps> = ({ size = 'medium' }) => {
  const spinnerSize = sizeMap[size];

  return (
    <SpinnerContainer style={{ width: spinnerSize, height: spinnerSize }}>
      <SpinnerGlow />
      <SpinnerRing />
      <SpinnerRing delay={-0.4} style={{ opacity: 0.7, width: '85%', height: '85%', top: '7.5%', left: '7.5%' }} />
      <SpinnerRing delay={-0.8} style={{ opacity: 0.4, width: '70%', height: '70%', top: '15%', left: '15%' }} />
      <SpinnerCore />
    </SpinnerContainer>
  );
};
